import { styled } from '@fluentui/utilities';
import { CalendarBase } from './Calendar.base';
import { styles } from './Calendar.styles';
export var Calendar = styled(CalendarBase, styles, undefined, {
    scope: 'Calendar',
});
//# sourceMappingURL=Calendar.js.map